export const CO6_BPM_SUBMIT = 'CO6_BPM_SUBMIT';
export const GIFTING_SCALE_TOGGLE_V2 = 'CWP_GIFTING_SCALE_V2';
export const GIFTING_INDV_STP_TOGGLE = 'CWP_VG_INDV_GIFTING_STP';
export const GIFTING_JOINT_STP_TOGGLE = 'CWP_VG_JOINT_GIFTING_STP';
export const GIFTING_TRUST_STP_TOGGLE = 'CWP_VG_TRUST_GIFTING_STP';
export const INTERNAL_TRANSFER_DIFFERENT_OWNERS_TOGGLE = 'CWP_Different_Owners';
export const INTERNAL_TRANSFER_STP_TOGGLE = 'CWP_Internal_Transfers_STP';
export const CWP_IRA_SCALE_TRAD = 'CWP_IRA_SCALE_TRAD';
export const CWP_IRA_SCALE_INH_ROTH = 'CWP_IRA_SCALE_INH_ROTH';
export const INTERNAL_TRANSFER_IT_JOINT_TOGGLE = 'CWP_IT_Joint_Enablement';
export const INTERNAL_TRANSFER_IT_TRUST_TOGGLE = 'CWP_IT_Trust_Enablement';
export const INHERITANCE_ESTATE_SCALE_TOGGLE = 'CWP_IRA_SCALE_ESTATE';
export const CWP_ESTATE_INDIVIDUAL_TO_STP = 'CWP_ESTATE_INDIVIDUAL_TO_STP';
export const CWP_IRA_SCALE_TRUST = 'CWP_IRA_SCALE_TRUST';
export const CWP_UPDATED_MXM_ENABLEMENT = 'CWP_Updated_MXM_Enablement';
export const CWP_IRA_SCALE_TRUST_TO_TRUST = 'CWP_IRA_SCALE_TRUST_TO_TRUST';
export const CWP_INTERNAL_GIFTING_MANAGED_ACCOUNTS = 'CWP_INTERNAL_GIFTING_MANAGED_ACCOUNTS';
export const INTELLEDOX_REDIRECT_AND_THRESHOLDS = 'INTELLEDOX_REDIRECT_AND_THRESHOLDS';
export const JOINT_INHERITANCE = 'JOINT_INHERITANCE';
export const INHERITANCE_IRA = 'INHERITANCE_IRA';
export const INHERITANCE_INDIVIDUAL = 'INHERITANCE_INDIVIDUAL';
export const CASH_PLUS_INTERNAL_TRANSFER = 'CASH_PLUS_INTERNAL_TRANSFER';
export const VCD_SETTLEMENT_FUNDS = 'VCD_SETTLEMENT_FUNDS';
export const DOC_CHECKLIST_INHERITANCE = 'DOC_CHECKLIST_INHERITANCE';
export const CWP_MULTI_INHERITANCE = 'CWP_MULTI_INHERITANCE';
export const CWP_IT_ESTATE_SCALE = 'CWP_IT_ESTATE_SCALE';
export const CWP_UGMA_UTMA_IT = 'CWP_UGMA_UTMA_IT';
export const CWP_CO0_MINOR = 'CWP_CO0_MINOR';
export const CWP_CO0_INHERITANCE = 'CWP_CO0_INHERITANCE';
export const CWP_CO0_INTERNAL_TRANSFERS = 'CWP_CO0_INTERNAL_TRANSFERS';
export const CWP_CO0_UPLOAD = 'CWP_CO0_UPLOAD';
export const TO_FROM_CONSOLIDATION = 'TO_FROM_CONSOLIDATION';
export const CWP_CO0_GIFTING = 'CWP_CO0_GIFTING';
export const CWP_DIVORCE = 'CWP_DIVORCE';
export const CWP_INHERITANCE_HIDE_SINGLE_FLOW = 'CWP_INHERITANCE_HIDE_SINGLE_FLOW';
